// sections/Hero.js
import React from 'react';
import './Hero.css';
import logo from '../assets/logo.png'; // 会社ロゴ
import heroVideo from '../assets/hero-video.mp4'; // ヒーロー動画
import Navigation from '../components/Navigation';

function Hero() {
  return (
    <section id="hero" className="hero-section">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-content">
        <img src={logo} alt="会社ロゴ" className="company-logo" />
        {/* 「Make Creator Happy.」のテキストはMissionセクションで動的に表示されるため、ここでは含めない */}
      </div>
      <Navigation position="right" /> {/* 右側ナビゲーション */}
    </section>
  );
}

export default Hero;